module.exports = __webpack_public_path__ + "media/images/emails/linkedin-db0f4e180f947fbe2361037c2ab48b89.png";